import { RootfiCompanyUseCase, RootfiSyncStatus } from '@prisma/client';

export enum TTransferPricingOnboardingStep {
  CONNECT_ERP = 'CONNECT_ERP',
  ADD_FIRST_POLICY = 'ADD_FIRST_POLICY',
  ACCOUNT_MAPPING = 'ACCOUNT_MAPPING',
  GO_LIVE = 'GO_LIVE',
}

export enum TransferPricingOnboardingStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export type CreateTransferPricingOnboardingParams = {
  serviceProviderEntityId: number;
};

export type UpdateTransferPricingOnboardingParams = {
  step: TTransferPricingOnboardingStep;
  policyId?: string;
};

export type TransferPricingOnboardingInformation = {
  serviceProviderEntityId: number;
  currentStep: TTransferPricingOnboardingStep;
  completedSteps: TTransferPricingOnboardingStep[];
  status: TransferPricingOnboardingStatus;
  selectedPolicyId: string | null;
};

export type RootfiSyncStatusResponse = {
  status: RootfiSyncStatus;
  lastSyncedAt: Date | null;
  lastSyncedAtText: string | null;
  useCase: RootfiCompanyUseCase;
  useCases: RootfiCompanyUseCase[];
  rootfiCompanyId: number;
};
